import React from "react";
import { MAROON, MAROON_TINT } from "./brandColors";

// Small boxed key/value tile - label on top (muted, uppercase, small), value
// below (bold). Used inside expanded detail panels (LinkedDocumentsPanel's
// Vehicle Maintenance Request / Quotation content) so a row of facts reads
// as distinct boxes rather than a run of plain "Label: value" text, echoing
// the same brand-maroon boxed-summary language as PermissionChecklist.jsx
// (feedback_react_permission_ui_pattern) and LinkedDocumentsPanel's own
// header strip.
const TONES = {
  neutral: { bg: "#F8F9FA", border: "#E9ECEF", color: "#212529" },
  maroon: { bg: MAROON_TINT, border: MAROON, color: MAROON },
  success: { bg: "#EAF7EE", border: "#1E7E34", color: "#1E7E34" },
};

// `onClick` makes the tile a filter button (Technician Duty Report, 2026-09-21):
// it gets a pointer + keyboard focus, and `active` draws it pressed - a heavier
// maroon outline - so a strip of tiles can double as the filter with no extra
// controls. Without `onClick` nothing changes for existing callers.
const InfoTile = ({ label, value, tone = "neutral", children, onClick, active = false, title }) => {
  const t = TONES[tone] || TONES.neutral;
  const clickable = typeof onClick === "function";
  return (
    <div
      className="rounded h-100"
      style={{
        background: active ? MAROON_TINT : t.bg,
        border: `1px solid ${active ? MAROON : t.border}`,
        boxShadow: active ? `inset 0 0 0 1px ${MAROON}` : undefined,
        padding: "4px 8px",
        cursor: clickable ? "pointer" : undefined,
        userSelect: clickable ? "none" : undefined,
      }}
      title={title}
      {...(clickable
        ? {
            role: "button",
            tabIndex: 0,
            "aria-pressed": active,
            onClick,
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            },
          }
        : {})}
    >
      <div className="text-uppercase" style={{ fontSize: 10, letterSpacing: 0.4, color: "#6c757d", lineHeight: 1.3 }}>
        {label}
      </div>
      <div className="fw-semibold" style={{ color: t.color, fontSize: 13, lineHeight: 1.4 }}>{children ?? value}</div>
    </div>
  );
};

export default InfoTile;
